import __request__ from "routing/request";
export function processingLoad(requestOptions) {
  return __request__("GET", "/system/pipelines/processing-load", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
